import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {Subject} from 'rxjs';
import {debounceTime} from 'rxjs/operators';
import { getNameFIle } from '../../../util/util';
import {
	ATTACHMENT_CATEGORIES,
	isAttachmentCategoryComplete
} from '../../../util/attachment-categories';

@Component({
    selector: 'app-attachment-view',
    templateUrl: './attachment-view.component.html',
    styleUrls: ['./attachment-view.component.scss'],
    standalone: false
})
export class AttachmentViewComponent implements OnInit {
	@Output() sendingFiles = new EventEmitter<any>();
	@ViewChild("fileDropRef", { static: false }) fileDropEl: ElementRef;
	@Input() hideNoteField: boolean = false;
	/** Activa select de categoría por archivo (flujo Archivos / create requirement). */
	@Input() enableCategory: boolean = false;
	@Input() accept: string = '*';
	files: any [] = [];
	showTable: boolean = false;
	errorMessage: string = '';
	successMessage: string = '';
	readonly categories = ATTACHMENT_CATEGORIES;
	private _success = new Subject<string>();
	private _error = new Subject<string>();
  constructor() { }

  ngOnInit() {
		this.messageErrorSuccess();
  }

	get totalBytes(): number {
		return this.files.reduce((sum, file) => sum + (Number(file?.size) || 0), 0);
	}

	formatFileSize(bytes: number): string {
		const size = Number(bytes) || 0;
		if (size < 1024) {
			return `${size} B`;
		}
		if (size < 1024 * 1024) {
			return `${(size / 1024).toFixed(size < 10 * 1024 ? 1 : 0)} KB`;
		}
		if (size < 1024 * 1024 * 1024) {
			return `${(size / (1024 * 1024)).toFixed(size < 10 * 1024 * 1024 ? 1 : 0)} MB`;
		}
		return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
	}

  onFileDropped($event) {
    this.prepareFilesList($event);
  }

  fileBrowseHandler(files) {
    this.prepareFilesList(files);
	}

	deleteFile(index: number) {
		this.files.splice(index, 1);
		this._success.next('Se elimino correctamente.');
		if (this.files.length <= 0) {
			this.showTable = false;
		}
		this.emitFiles();
  }

	prepareFilesList(files: Array<any>) {
		this.showTable = true;
		for (const item of files) {
				item.note = '';
				if (this.enableCategory) {
					item.category = item.category || '';
					item.categoryother = item.categoryother || '';
				}
				this.files.push(item);
		}
		this.emitFiles();
		this.fileDropEl.nativeElement.value = "";
		getNameFIle(this.files)
	}

	onCategoryChange(file: any) {
		if (file.category !== 'otro') {
			file.categoryother = '';
		}
		this.emitFiles();
	}

	emitFiles() {
		this.sendingFiles.emit(this.files);
	}

	areCategoriesValid(): boolean {
		if (!this.enableCategory) {
			return true;
		}
		return this.files.every((file) => isAttachmentCategoryComplete(file));
	}

	messageErrorSuccess() {
		this._success.subscribe(message => this.successMessage = message);
		this._success.pipe (
			debounceTime(2000)
		).subscribe(() => this.successMessage = '');
		this._error.subscribe(message => this.errorMessage = message);
		this._error.pipe (
				debounceTime(2000)
		).subscribe(() => this.errorMessage = '');
	}
}
